import React, { Component } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import {Modal, Button } from 'react-bootstrap';

const clientID = "Af8Aj6tTR-c3k05rk_h-ydVdphrYKy-rn96xdDVeUI_kzcNstfvfv_i1UY8Pq8eJugH05P0HatYp2iW9" //real
//const clientID = "AYjS8JJEeQjpxiAmTyDqOJANSOJgxgmjuf4IPFRIqmqsu0oZlrGZ-vz0NB5p86pfNcf55-zEWpznAy4O" //test
class PaypalCheckoutBtn extends Component {
  constructor(props){
    super(props);
    this.state = {
       paidFor:false,
       showModal:false,
       error:null,
       finalCur:null,
       finalPrice:null,
       descriptionText:"",
       cartArray:[],
       checkoutOrder:{},
    };

    this.setval = this.setval.bind(this)
    this.handleApprove = this.handleApprove.bind(this)
    this.setError = this.setError.bind(this)
    this.closeModal = this.closeModal.bind(this)

  }

  setval(obj){
    this.setState(obj)
  }
  handleApprove(orderID){

    this.setState({paidFor:true,showModal:true})
  }
  setError(string){
    this.setState({error:string})
  }
  closeModal(){
    this.setState({showModal:false,paidFor:false,error:null})
    this.props.setval({currentPage:"frontpage",filter:{},shoppingCart:{},chosenProduct:{}})
  }
  componentDidMount(){
    var obj = JSON.parse( JSON.stringify( this.props.shoppingCart))
    // console.log(JSON.stringify(obj))
    var name = ""
    var des = ""
    var qty = 0
    var unit_price = 0
    var end_str = ""
    var array = []
    var arr_obj = {}
    var ref_id = Date.now()
    for (var q in obj){
      name = obj[q]["name"]
      for (var v in obj[q]["options"]){
        des = des + " " + v +" : "+obj[q]["options"][v] + "  ||  "
      }
      des = des.slice(0,-4)
      qty = obj[q]["quantity"]
      unit_price = obj[q]["unit_price"]

      arr_obj = {"description":name+", "+qty+" units @ USD"+unit_price+ ", [ " + des +" ] ","amount":{"value":parseFloat(unit_price)*parseFloat(qty),"currency_base":"USD"},"reference_id":ref_id}
      ref_id = ref_id + 1
      array.push(arr_obj)
      end_str = end_str + name + " , " + qty + " units " + "@ USD" + unit_price + ", [ " + des +" ] " + ";  "
      des = ""
    }

    end_str = end_str.slice(0,-3)
    this.setState({descriptionText:end_str,cartArray:array})
    //alert(end_str)
    // alert(JSON.stringify(array))

  }      
      
  render(){
    if(this.state.paidFor){
        //alert("Thank you. Please take a screenshot of the payment details below:\n Applicant Name: "+this.props.applicantName+"\n Group applied: "+this.props.chosengroup+ "\n Amount paid (USD): "+this.props.USDprice);
      }
      if(this.state.error===true){
        alert("Connection to PayPal was unsuccessful, and the transaction was not complete. Please try again.")
        this.setState({error:null})
        //alert(this.state.error);
      }
    return (
        <PayPalScriptProvider options={{'client-id':clientID,
                                          'locale':"en_HK",
                                            //currency:this.state.chosencurrency,
                                          }}>

             <Modal show={this.state.showModal} onHide={this.closeModal}>
                    <Modal.Header closeButton>
                    <Modal.Title>Payment Summary</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{"Thank you for your purchase at YT Magasin. A receipt from Paypal shall be sent to your inputteed email. Kindly note your payment below."}</p>
                        <p>{"Total Amount paid: "+this.state.finalCur+" "+this.state.finalPrice}</p>
                        <p>{(this.state.checkoutOrder==(null||undefined))?"":"Order ID: "+this.state.checkoutOrder["id"]}</p>
                        <p>{"Current time: "+new Date().toLocaleString("en-US")}</p>
                        </Modal.Body>
                    <Modal.Footer>
                    <Button variant="primary" onClick={this.closeModal}>
                        Close
                    </Button>

                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showError} onHide={this.closeModal}>
                    <Modal.Header closeButton>
                    <Modal.Title>Payment failed: Error occured.</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{"Payment failed. Please provide the correct information or contact our administration for help."}</Modal.Body>
                    <Modal.Footer>
                    <Button variant="primary" onClick={this.closeModal}>
                        Back to Home
                    </Button>

                    </Modal.Footer>
                </Modal>

      <PayPalButtons
        onClick={(data,actions)=>{
          const alreadyBought = false;
          if(alreadyBought){
            this.setError("You already paid");
            return actions.reject();
          } else {
            return actions.resolve();
          }
        }}
        createOrder={(data,actions)=>{
          return actions.order.create({
            // purchase_units:[
            //   {
            //     description: this.state.descriptionText,
            //     amount: {
            //       value: this.props.billTotal,
            //       currency_base: "USD"
            //     },
            //   },
            // ],
            purchase_units: this.state.cartArray,
          });
        }}
        
        onApprove = {async (data,action)=>{
          const order = await action.order.capture();
          // const curr = order.purchase_units[0].amount.currency_code
          // const value = order.purchase_units[0].amount.value
          const curr = order.purchase_units[0].amount.currency_code
          const value = this.props.billTotal
          console.log("order",order);
          // this.props.setval({checkoutOrder:order})

          this.handleApprove(data.orderID);
          this.setState({finalCur:curr,finalPrice:value,checkoutOrder:order})
        }}

        onCancel ={()=>{}}
        onError = {(err)=>{
          this.setError(err);
          console.log("Paypal checkout onError", err);
        }}

        />

    </PayPalScriptProvider>
    );
  }
  }
  

export default PaypalCheckoutBtn;
